module.exports = [{"key":"10","title":"进入中间表"},{"key":"11","title":"生成申请单"},{"key":"12","title":"申请单签收"},{"key":"13","title":"申请单全部完成"},{"key":"14","title":"申请单报告生成"},{"key":"15","title":"报告回传"}]


//////////////////
// WEBPACK FOOTER
// ./static/specTracker/specTracker-his.json
// module id = 7VDK
// module chunks = 2